import React, { Component } from 'react';
import Services from '../components/pages/home';
import About from '../components/pages/about';
import Bloge from '../components/pages/bloge';
import WebApi from '../components/pages/web-api';
import Learning from '../components/pages/learning';
import Pricing from '../components/pages/pricing';
import Plans from '../components/pages/plans';
import MarketMap from '../components/pages/market-map';
import NavBar from '../components/custom/navbar/NavA';
import Footer from '../components/custom/footer/FooterB';
// import Login from '../components/pages/login';
import {  BrowserRouter , Route , Redirect,Switch} from 'react-router-dom';



class MainRouter extends Component {
  render() {
    // const notInLogin = /^(?!.*(\/home)).*$/
    // const _path = {["/", "/about", "/pricing", "/web-api", "/market-map", "/bloge"]}
    return (
      <BrowserRouter>
          <Route path="/(about|bloge|pricing|web-api|market-map|learning|services| |)" exact={true} component={NavBar}/>
          <Route exact path="/" component={MarketMap}/>
          <Route exact path="/about" component={About}/>
          <Route exact path="/bloge" component={Bloge}/>
          <Route exact path="/pricing" component={Pricing}/>
          <Route exact path="/web-api" component={WebApi}/>
          <Route exact path="/learning" component={Learning}/>
          <Route exact path="/plans" component={Plans}/>
          <Route exact path="/services" component={Services}/>
          {/* <Route exact path="/login" component={Login}/> */}
          <Route path="/(about|bloge|pricing|web-api|market-map|learning|services| |)" exact={true}  component={Footer}/>
      </BrowserRouter>
          
    )
  }
}


export default MainRouter;